import { useState, useCallback } from "react";
import { useAuth } from "./useAuth";

interface RequireAuthOptions {
  title?: string;
  description?: string;
}

export const useRequireAuth = () => {
  const { user } = useAuth();
  const [showAuthPrompt, setShowAuthPrompt] = useState(false);
  const [promptOptions, setPromptOptions] = useState<RequireAuthOptions>({});

  const requireAuth = useCallback(
    (action: () => void, options?: RequireAuthOptions) => {
      if (user) {
        action();
      } else {
        setPromptOptions(options || {});
        setShowAuthPrompt(true);
      }
    },
    [user]
  );

  const closeAuthPrompt = useCallback(() => {
    setShowAuthPrompt(false);
  }, []);

  return {
    user,
    isAuthenticated: !!user,
    requireAuth,
    showAuthPrompt,
    closeAuthPrompt,
    promptOptions,
  };
};
